module.exports = __webpack_public_path__ + "img/default-avatar.758a5444.jpg";